import {Text} from '@mc/ui-v4';

import React from 'react';
import {JsonImportPhase, JsonImportProgressVO} from '../../../api';
import './JsonImportProgress.scss';

const percent = (done?: number, total?: number): number => {
    if (!total || total <= 0) {
        return 0;
    }
    return Math.min(100, Math.round(((done ?? 0) / total) * 100));
};

const ProgressBar: React.FC<{value: number}> = ({value}) => (
    <div className="json-import-progress-bar my-1">
        <div className="json-import-progress-bar__fill" style={{width: `${value}%`}} />
    </div>
);

export const JsonImportProgressContent: React.FC<{progress: JsonImportProgressVO}> = ({progress}) => {
    const inImages = progress.phase === JsonImportPhase.IMAGES;
    const recordsPct = percent(progress.recordsDone, progress.recordsTotal);
    const imagesPct = percent(progress.imagesDone, progress.imagesTotal);

    return (
        <>
            <Text strong>{inImages ? 'Import záznamů dokončen' : 'Importují se záznamy…'}</Text>
            <ProgressBar value={inImages ? 100 : recordsPct} />
            <Text intent={'secondary'}>
                {progress.recordsDone ?? 0} z {progress.recordsTotal ?? 0} záznamů
            </Text>

            {inImages && (
                <div className="mt-3">
                    <Text strong>Načítají se obrázky…</Text>
                    {progress.imagesTotal && progress.imagesTotal > 0 ? (
                        <>
                            <ProgressBar value={imagesPct} />
                            <Text intent={'secondary'}>
                                {progress.imagesDone ?? 0} z {progress.imagesTotal} obrázků
                            </Text>
                        </>
                    ) : (
                        <Text intent={'secondary'}>Zjišťují se obrázky k načtení…</Text>
                    )}
                </div>
            )}
        </>
    );
};
